module.exports = __webpack_public_path__ + "media/images/training-image-9d563cf2973323d65d94060e73ab29a6.png";